import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

const UserDataContext = createContext();

function UserDataContextProvider(props) {
  const [userData, setUserData] = useState(undefined);

  async function getUserData() {
    const token = localStorage.getItem("token");

    const loggedInRes = await axios.get(
      `${process.env.REACT_APP_BACKEND}/auth/userData`,
      {
        headers: {
          jwtToken: token,
        },
      }
    );
    setUserData(loggedInRes.data);
  }

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <UserDataContext.Provider value={{ userData, getUserData }}>
      {props.children}
    </UserDataContext.Provider>
  );
}

export default UserDataContext;
export { UserDataContextProvider };
